<template>
  <div class="flex flex-col bg-white px-2">
    <div class="flex flex-col gap-[5px] pt-3 mt-3">
      <db-form class="flex flex-col gap-[5px]">
        <div class="flex w-full flex-col">
          <p class="self-start text-sm">
            {{ $t("landing.reset_password.set_new_password") }}
          </p>
        </div>
        <div class="w-full flex flex-col items-center pb-1 pt-6">
          <DbPasswordInput
            v-model="user.password"
            :placeholder="$t('account.password') + '*'"
            :label="$t('landing.password') + '*'"
            variant="white"
            name="password"
            :class="{
              'border-red-500':
                !isFieldValid('password', user) && form.processing,
            }"
            :ariainvalid="
              !isFieldValid('password', user) && form.processing ? 'true' : ''
            "
          />
          <span
            v-if="!isFieldValid('password', user) && form.processing"
            class="text-red-500"
          >
            {{ $t("account.validation.password") }}
          </span>
        </div>
        <div class="w-full flex flex-col items-center pb-6">
          <DbPasswordInput
            v-model="user.password_confirmation"
            :placeholder="$t('account.password_confirmation') + '*'"
            :label="$t('account.password_confirmation') + '*'"
            variant="white"
            name="password_confirmation"
            :class="{
              'border-red-500':
                !isFieldValid('password_confirmation', user) && form.processing,
            }"
            :ariainvalid="
              !isFieldValid('password_confirmation', user) && form.processing
                ? 'true'
                : ''
            "
          />
          <span
            v-if="
              !isFieldValid('password_confirmation', user) && form.processing
            "
            class="text-red-500"
          >
            {{ $t("account.validation.password_confirmation") }}
          </span>
        </div>
        <db-button
          id="login"
          variant="brand-primary"
          class-list="w-full mt-2"
          @click="reset"
        >
          {{ $t("landing.reset_password.confirm") }}
        </db-button>
      </db-form>
      <div class="flex w-full pt-16">
        <p class="text-sm text-gray-400">
          {{ $t("landing.required_field") }}
        </p>
      </div>
    </div>
  </div>

  <AppModal
    id="reset-password-modal"
    :visible="form.successful"
    modal-size="md"
    modalType="accept"
    cancelText="landing.reset_password.to_login"
    @hide-modal="close"
  >
    <!-- Modal body -->
    <div class="p-6 flex flex-col justify-center w-full">
      <h2>********</h2>
      <h2 class="font-bold">
        {{ $t("landing.reset_password.password_changed") }}
      </h2>
    </div>
  </AppModal>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import store from "@/store";
import DbButton from "@/components/DB-Components/DbButton.vue";
import router from "@/router";
import {
  isFieldRequired,
  isFieldValid,
  validationMessage,
} from "@/utils/users/methods";
import AppModal from "./AppModal.vue";
import DbPasswordInput from "./DB-Components/DbPasswordInput.vue";

export default defineComponent({
  components: { DbButton, AppModal, DbPasswordInput },
  name: "LoginComponent",

  setup() {
    const router = useRouter();
    const route = useRoute();
    const token = route.params.token;
    if (!token) {
      router.push("/login");
    }
    const title = process.env.NODE_ENV;
    const user = ref({
      password: "",
      password_confirmation: "",
      code: token,
    });

    const errors = ref({
      password: false,
      password_confirmation: false,
      code: false,
    });

    const form = ref({
      errors: {},
      processing: false,
      successful: false,
    });

    const resetErrors = () => {
      errors.value = {
        password: false,
        password_confirmation: false,
        code: false,
      };
    };

    const reset = async () => {
      form.value.successful = false;
      form.value.processing = true;
      if (!isFormValid.value) {
        return;
      }
      await store.dispatch("toggleLoading", true);
      resetErrors();
      await store
        .dispatch("UserStore/resetPasswordLink", user.value)
        .then(async (res) => {
          form.value.successful = true;
        })
        .catch((error) => {
          errors.value = {
            password: true,
            password_confirmation: true,
            code: true,
          };
        })
        .finally(() => {
          store.dispatch("toggleLoading", false);
        });
    };

    const isFormValid = computed(() => {
      let isFilled = true;

      if (form.value.processing == false) {
        const isFilled =
          (Object.keys(user.value) as Array<keyof typeof user.value>).filter(
            (fieldName) =>
              isFieldRequired(fieldName as any) &&
              (user.value[fieldName] == null ||
                user.value[fieldName]?.length === 0)
          ).length > 0
            ? false
            : true;

        return isFilled;
      }

      return Object.keys(user.value).every((fieldName) =>
        isFieldValid(fieldName as any, user.value)
      );
    });

    const close = () => {
      router.push("/login");
    };

    return {
      user,
      reset,
      title,
      errors,
      router,
      isFieldValid,
      form,
      close,
    };
  },
});
</script>
